import Table from'common/components/Table/Table';export default Table;